<div id="footer" class="disclaimer-text custom-rte justify-content-center" role="contentinfo">
  <div class="content">
    © 2026. Deloitte refers to one or more of Deloitte Touche Tohmastua limited by guarantee("DTTL"),its network of member firms, and their related entities. DTTL and each of its member firms are legally separate and indepedent entities. DTTL(also referred to as
    "Deloitte Global") does not provide services to clients.Please see  <a href="https://www.deloitte.com/about" target="_blank">www.deloitte.com/about</a> to learn more about our global network of member firms.
  </div>
  <div class="footer-links">
    <a href="javascript:void(0);" (click)="openCookieNotice($event)">Cookie Notice</a>
    <span class="separator">|</span>
    <a class="cookie-settings-link" href="javascript:void(0);" (click)="openCookieSettings($event)">Cookie Settings</a>
  </div>
</div>
